export interface AdvisorValueProp {
  title: string
  bullets: string[]
  image: string
}

const ADVISOR_VALUE_PROP: AdvisorValueProp = {
  title: 'Free tools to support Portfolio Projects',
  bullets: [
    'Manage your portfolio from a single platform',
    'Invite up to 20 teammates to collaborate',
    'Access all tools and workflows',
  ],
  image: '/auth/advisor-product.webp',
}

export function useAuthAdvisorPanel() {
  return { valueProp: ADVISOR_VALUE_PROP }
}
